module.exports = __webpack_public_path__ + "img/bg-3.f75d2bab.png";